import alphaSms from "./alphaSms.js";
import flySms from "./flySms.js";
import hicellSms from "./hicellSms.js";
import turboSms from "./turboSms.js";
import smsClub from "./smsClub.js";
import lifecellSms from "./lifecellSms.js";
export default { alphaSms, flySms, hicellSms, turboSms, smsClub, lifecellSms };
